import { IFormProps } from '../../componets/interfaces/formProps';
import { paths } from '../../config';
import MainContainer from '../main-container';
import Form from './legalProcessDistrictForm';
import List from './legalProcessDistrictList';

const settings = {
    pathRegister: paths.legalProcessDistrictRegister,
    pathList: paths.legalProcessDistrict,
    apiPath: 'legal-process-districts',
    permissionAdmin: null,
    title: 'Comarca',
};

const FormEntity: React.FC = () => {
    return (
        <MainContainer>
            <Form settings={settings} />
        </MainContainer>
    );
};

const ListEntity: React.FC = () => {
    return (
        <MainContainer>
            <List settings={settings} />
        </MainContainer>
    );
};

export { FormEntity, ListEntity };
